<template>
  <div class="create-shipper">
    <loading v-if="loading"></loading>
    <div class="header">
        <div class="layout-wrapper">
            <header id="page-topbar">
                <BaseButton variant="secondary" @click="$router.push({path: '/partners', hash: '#second'})">Quay lại</BaseButton>
            <div class="title">
                <p>Thêm mới shipper</p>
            </div>
                <el-button type="primary" @click="submitForm('ruleForm')">Hoàn tất</el-button>
            </header>
        </div>
    </div>
    
    <div class="boxContent boxContentExt" style="margin-top: 110px">
      <div class="__card">
        <LayoutCardTitle>Thông tin cơ bản</LayoutCardTitle>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" style="width: 100%;" :inline="true">
            <el-row style="margin-bottom: 24px">
              <el-col :span="20">
                <el-form-item label="Họ và tên" prop="shipperName">
                  <el-input v-model="ruleForm.shipperName" placeholder="Nhập tên shipper" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-bottom: 24px">
              <el-col :span="20">
                <el-form-item label="Số điện thoại" prop="phoneNo">
                  <el-input v-model="ruleForm.phoneNo" placeholder="Nhập số điện thoại" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-bottom: 24px">
              <el-col :span="20">
                <el-form-item label="Địa chỉ" prop="address">
                  <el-input v-model="ruleForm.address" placeholder="Nhập địa chỉ cụ thể" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-bottom:24px">
              <el-col :span="20">
                <el-form-item label="Ghi chú" class="mb-0" prop="note">
                  <el-input :rows="5" v-model="ruleForm.note" type="textarea" placeholder="Nhập mô tả…" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { ShipperServices } from '@/services/nextshop/shipper.service'
export default {
    data() {
        return {
            loading: false,
            inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
            ruleForm: {
                shipperName: '',
                phoneNo: '',
                address: '',
                note: ''
            },
            rules: {
                shipperName: [
                    { required: true, message: 'Họ và tên không được bỏ trống', trigger: 'blur' },
                ],
                phoneNo: [
                    { required: true, message: 'Số điện thoại không được bỏ trống', trigger: 'blur' },
					          { min: 10, max: 11, message: 'Số điện thoại không hợp lệ', trigger: 'blur' }
                ],
            },
        }
    },

    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.createShipper();
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        }, 

        async createShipper() {

            let param = {
                name: this.ruleForm.shipperName,
                phoneNo: this.ruleForm.phoneNo,
                isPerson: true,
                merchantId: this.inforAccount.merchantId,
                // address: this.ruleForm.address,
                // note: this.ruleForm.note,
                ...(this.ruleForm.address && {address: this.ruleForm.address}),
                ...(this.ruleForm.note && {note: this.ruleForm.note})
            }
            try {
              const res = await ShipperServices.createNewShipper(param)
              if (res.success) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: '<h5 style="color:#67c23a">Thêm mới shipper thành công</h5><p style="color:#23313E">Shipper đã được thêm vào danh sách.</p>',
                    type: 'success'
                });
                this.$router.push({path: '/partners', hash: '#second'});
              }
            } finally {
              this.loading = false
            }
        },
    }

}
</script>


<style lang="scss" scoped>

.boxContent .__card {
  max-width: 960px;
}
.layout-wrapper {
  position: relative;

  #page-topbar {
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;

    .title{
      position: absolute;
      font-weight: 600;
      font-size: 24px;
      color: #23313e;
      cursor: pointer;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      align-self: center;
      
      p {
        margin: 0;
      }
    }
    
    .content {
      margin-top: 5.5em;
      padding: 20px 16.6% 120px 16.6%;
      min-height: 80vh;
    }
  }
}
</style>

<style lang="scss">
.boxContent {
  margin: 12px 0;
}

.el-form-item {
  width: 100%;
  margin-bottom: 0;
}

.el-form-item__label {
  color: #9093A4;
}

.el-form-item__content {
  width: 70%;
}
</style>>
